import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './focus-panel.module.css';
import { capitalize, safeCallback, useMediaQuery } from '../../../library';
import { CloseButton } from '../../buttons';
export function FocusPanel(_a) {
    var _b = _a.zIndex, zIndex = _b === void 0 ? 100 : _b, _c = _a.variation, variation = _c === void 0 ? 'standard' : _c, _d = _a.buildIn, buildIn = _d === void 0 ? window.document.body : _d, _e = _a.shiftBy, shiftBy = _e === void 0 ? 0 : _e, _f = _a.overlayStyle, overlayStyle = _f === void 0 ? 'default' : _f, _g = _a.backgroundStyle, backgroundStyle = _g === void 0 ? 'default' : _g, open = _a.open, onClose = _a.onClose, children = _a.children;
    var focusPanelRef = useRef(null);
    var isTouch = useMediaQuery('screen and (pointer: coarse)');
    useEffect(function () {
        var _a;
        (_a = focusPanelRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        !isTouch ? window.document.body.classList.toggle('focusPanelOpen', !!open) : window.document.body.classList.remove('focusPanelOpen');
        return function () { return window.document.body.classList.remove('focusPanelOpen'); };
    }, [open, isTouch]);
    return ReactDOM.createPortal(React.createElement("dialog", { open: open, style: { zIndex: zIndex }, className: classNames(styles.focusPanelDialog, styles[overlayStyle], "kplr_focusPanelDialog") },
        React.createElement("div", { className: styles.focusPanelOverlay, onClick: onClose }),
        React.createElement("div", { className: styles.focusPanelContainer, ref: focusPanelRef, style: { zIndex: zIndex, right: "".concat(shiftBy, "px") } },
            React.createElement("div", { className: classNames(styles.focusPanelBackground, styles[variation], styles["style".concat(capitalize(backgroundStyle))]) },
                React.createElement(CloseButton, { onClick: function () { return safeCallback(onClose); } }),
                children))), buildIn);
}
export default FocusPanel;
